import { DynamicFormControlLayout, serializable } from '@ng-dynamic-forms/core';
import { CustomDynamicSelectModel, CustomDynamicSelectModelConfig } from '../shared-models/custom-dynamic-select.model';

export const TYPE_SELECT_FILTER = 'SELECT-FILTER';

export interface SelectFilterModelConfig<T> extends CustomDynamicSelectModelConfig<T> {
}

export class SelectFilterModel<T> extends CustomDynamicSelectModel<T> {
  @serializable() readonly type: string = TYPE_SELECT_FILTER;

  constructor(config: SelectFilterModelConfig<T>, layout?: DynamicFormControlLayout) {
    super(config, layout);

    // tell ng-dynamic-forms not to display additional label and errorMessages
    this.additional = {
      ...this.additional,
      isFormFieldControl: true
    };
  }
}
